import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./ContactForm.scss";
import { EMERGENCY_CONTACT_NUMBER } from "../../utils/Constant";
import { getCurrentDateFormatted, whatsAppBotListener } from "../../utils/Utils";
import { FaPhoneAlt } from "react-icons/fa";

// Validation schema using Yup
const ContactFormSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Name is too short")
        .max(50, "Name is too long")
        .required("Name is required"),
    age: Yup.number()
        .typeError("Age must be a number")
        .min(1, "Please enter a valid age")
        .required("Age is required"),
    service: Yup.string().required("Please select a service"),
});

const ContactForm = () => {
    const initialValues = {
        name: "",
        age: "",
        service: "TEETH CLEANING",
        message: "",
    };

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const formattedString =
            `Denvia Dental Clinic \n` +
            `Appointment / Inquiry \n\n` +
            `Date: ${getCurrentDateFormatted()}\n` +
            `Name: ${values.name}\n` +
            `Age: ${values.age}\n` +
            `Service: ${values.service}\n` +
            `Message: ${values.message}`;

        console.log("Form values:");
        console.log(formattedString);

        whatsAppBotListener(formattedString);

        setTimeout(() => {
            resetForm();
            setSubmitting(false);
        }, 1000);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ContactFormSchema}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting, errors, touched }) => (
                <Form>
                    <div className="row">
                        {/* Name */}
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <Field
                                    type="text"
                                    name="name"
                                    className={`form-control ${errors.name && touched.name ? "is-invalid" : ""}`}
                                    placeholder="Enter your name..."
                                />
                                <ErrorMessage name="name" component="div" className="invalid-feedback" />
                            </div>
                        </div>

                        {/* Age */}
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label htmlFor="age">Age</label>
                                <Field
                                    type="number"
                                    name="age"
                                    className={`form-control ${errors.age && touched.age ? "is-invalid" : ""}`}
                                    placeholder="Enter your age..."
                                />
                                <ErrorMessage name="age" component="div" className="invalid-feedback" />
                            </div>
                        </div>

                        {/* Service */}
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label htmlFor="service">Service</label>
                                <Field
                                    as="select"
                                    name="service"
                                    className={`form-control ${errors.service && touched.service ? "is-invalid" : ""}`}
                                >
                                    <option value="TEETH CLEANING">TEETH CLEANING</option>
                                    <option value="DENTAL IMPLANTS">DENTAL IMPLANTS</option>
                                    <option value="ROOT CANAL TREATMENT">ROOT CANAL TREATMENT</option>
                                    <option value="CROWNS & BRIDGES">CROWNS & BRIDGES</option>
                                    <option value="COMPLETE DENTURES">COMPLETE DENTURES</option>
                                    <option value="BRACES AND CLEAR ALIGNERS">BRACES AND CLEAR ALIGNERS</option>
                                    <option value="TEETH WHITENING">TEETH WHITENING</option>
                                    <option value="TEETH EXTRACTION">TEETH EXTRACTION</option>
                                    <option value="PEDIATRIC & PREVENTIVE DENTISTRY">PEDIATRIC & PREVENTIVE DENTISTRY</option>
                                    <option value="VENEERS & LAMINATES">VENEERS & LAMINATES</option>
                                    <option value="COSMETIC DENTISTRY AND SMILE MAKEOVERS">COSMETIC DENTISTRY AND SMILE MAKEOVERS</option>
                                    <option value="FULL MOUTH RAHBILITATION">FULL MOUTH RAHBILITATION</option>
                                    <option value="DIGITAL DENTISTRY">DIGITAL DENTISTRY</option>
                                    <option value="LASER DENTISTRY">LASER DENTISTRY</option>
                                     <option value="OTHER">OTHER</option>
                                </Field>
                                <ErrorMessage name="service" component="div" className="invalid-feedback" />
                            </div>
                        </div>

                        {/* Message */}
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor="message">Messages</label>
                                <Field
                                    as="textarea"
                                    name="message"
                                    className="form-control"
                                    placeholder="Enter your message..."
                                    rows="3"
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="col-lg-6">
                            <button type="submit" className="btn appointment-btn" disabled={isSubmitting}>
                                {isSubmitting ? "Submitting..." : "Book Appointment"}
                            </button>
                        </div>

                        {/* Contact Info */}
                        <div className="col-lg-6">
                            <a href={`tel:${EMERGENCY_CONTACT_NUMBER}`} className="appointment-call" style={{ textDecoration: "none" }}>
                                <div className="icon">
                                    <FaPhoneAlt />
                                </div>
                                <div className="call-text">
                                    <p>Call Us On</p>
                                    <h6>{EMERGENCY_CONTACT_NUMBER}</h6>
                                </div>
                            </a>
                        </div>

                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ContactForm;
